// NotificationSection.tsx
import React, { useState } from "react";
import SectionCard from "./SectionCard";
import Field from "./Field";
import Toggle from "./Toggle";
import { WhatsAppData } from "./types";

const input = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm";
const tabs = ["WhatsApp", "SMS", "Email"];

interface Props {
  data: WhatsAppData;
  onChange: (data: WhatsAppData) => void;
}

export default function NotificationSection({ data, onChange }: Props) {
  const [tab, setTab] = useState("WhatsApp");
  const set = (key: keyof WhatsAppData, value: any) => onChange({ ...data, [key]: value });

  return (
    <SectionCard step={3} title="Notification Settings">
      <div className="flex gap-6 border-b border-gray-100">
        {tabs.map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`pb-2 text-sm font-medium border-b-2 ${
              tab === t ? "border-green-600 text-green-600" : "border-transparent text-gray-400"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {tab === "WhatsApp" && (
        <div className="space-y-4 pt-2">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-sm font-medium">Enable WhatsApp Notifications</p>
              <p className="text-xs text-gray-400">Send WhatsApp messages to customers automatically</p>
            </div>
            <Toggle on={data.enabled} onToggle={(v) => set("enabled", v)} />
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="WhatsApp Business Number" hint="Number connected with WhatsApp Business API">
              <input className={input} value={data.number} onChange={(e) => set("number", e.target.value)} />
            </Field>
            <Field label="Message Language">
              <select className={input} value={data.language} onChange={(e) => set("language", e.target.value)}>
                <option>English</option>
                <option>Arabic</option>
                <option>Hindi</option>
              </select>
            </Field>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <div className="flex justify-between items-center">
              <p className="text-sm font-medium">Send Order Ready Notification</p>
              <Toggle on={data.sendOrderReady} onToggle={(v) => set("sendOrderReady", v)} />
            </div>
            <div className="flex justify-between items-center">
              <p className="text-sm font-medium">Send payment reminder for outstanding</p>
              <Toggle on={data.sendPaymentReminder} onToggle={(v) => set("sendPaymentReminder", v)} />
            </div>
          </div>
        </div>
      )}

      {tab !== "WhatsApp" && (
        <p className="text-sm text-gray-400 pt-2">{tab} settings go here.</p>
      )}
    </SectionCard>
  );
}
